export const affinity = [
  { x: 'Gamers', y: 5.59, index: 0 },
  { x: 'Technophiles', y: 4.62, index: 1 },
  { x: 'Hardcore\nGamers', y: 4.38, index: 2 },
  { x: 'Movie\nLovers', y: 4.19, index: 3 },
  { x: 'Shutterbugs', y: 3.78, index: 4 },
]
